import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, imageSlot, ornament, ornamentPoint } from "./kit";
import type { LabelTemplate } from "./types";

// Old World heraldic: the visitor's crest or logo in a laurel pair, then the
// house name and a ribbon. The image slot is the one uploaded image, so it is
// the first element (the back of the stack) and the laurels draw over it.
function wine(): CanvasData {
  const b = "wine";
  // laurel-pair's arc centre is SVG (100, 84), placed at (45, 19). Its opening
  // (measured from the rasterised laurel) is about 27 mm wide from y 4 to 29
  // and narrows towards the tie, so the slot is a 25 mm square in that band:
  // a logo's corners clear the inner leaves by about 1 mm.
  const slot = imageSlot({ x: 32.5, y: 4.5, width: 25, height: 25 }, "Add your crest or logo");
  const laurel = ornament("laurel-pair", INK.bronze, { width: 47, at: [45, 19], anchor: [100, 84] });
  const ribbon = ornament("straight-ribbon", INK.burgundy, { width: 44, at: [45, 63], anchor: [150, 21] });
  const band = ornamentPoint(ribbon, 150, 21);
  return doc(b, INK["warm-white"], [
    slot,
    laurel,
    centred(b, { text: "HOUSE OF", font: "cormorant", size: 2.2, color: INK.charcoal, baseline: 46.4, tracking: 0.3 }),
    centred(b, { text: "YOUR NAME", font: "cinzel", bold: true, size: 6, color: INK.burgundy, baseline: 54.8, tracking: 0.06 }),
    ribbon,
    centred(b, { text: "Est. 2026", font: "cormorant", italic: true, size: 2.6, color: INK["warm-white"], baseline: band[1] + 1.3, tracking: 0.04 }),
    centred(b, { text: "Reserve · Stellenbosch", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 88, tracking: 0.2 }),
  ]);
}

export const heraldicCrest: LabelTemplate = {
  key: "heraldic-crest",
  name: "Heraldic crest",
  occasion: "classic",
  style: "Old World heraldic",
  description: "Your crest or logo in laurels, with a ribbon and house name.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
